<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('plugin.activity.title') }}</span>
          </div>
        </div>
        <el-form style="min-width: 1000px;" :inline="true" :model="formInline">
          <el-form-item :label="$t('plugin.activity.name')" class="mar_l20">
            <el-input style="width: 200px;" v-model="formInline.name" :placeholder="$t('plugin.activity.namePh')" @input="getActive"></el-input>
          </el-form-item>
        </el-form>
        <div class="t_l pad_l_20 mar_tb20">
          <el-button type="primary" size="medium" @click="handleEdit(false,'active')">{{ $t('plugin.activity.add') }}</el-button>
        </div>
      </div>
      <div class="ba_f pad_20">
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%;" @selection-change="setSelectRows">
          <el-table-column prop="id" :label="$t('common.sort')" width="60"></el-table-column>
          <el-table-column prop="name" :label="$t('plugin.activity.name')"></el-table-column>
          <el-table-column :label="$t('plugin.activity.enrollTime')" align="center" width="150">
            <template slot-scope="scope">
              <div>{{ $moment(scope.row.enrollStartAt*1000).format('YYYY-MM-DD HH:mm:ss') }}</div>
              <div>{{ $moment(scope.row.enrollEndAt*1000).format('YYYY-MM-DD HH:mm:ss') }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('plugin.activity.type')" align="center">
            <template slot-scope="scope">{{ activityTypeLabel(scope.row.type) }}</template>
          </el-table-column>
          <el-table-column prop="condition" :label="$t('plugin.activity.completeOrders')" min-width="100" align="center">
            <template slot-scope="scope">{{ scope.row.type == 1 ? '--' : scope.row.condition }}</template>
          </el-table-column>
          <el-table-column prop="reward" :label="$t('plugin.activity.completeReward')"></el-table-column>
          <el-table-column :label="$t('plugin.activity.joinComplete')" min-width="120" align="center">
            <template slot-scope="scope">
              <span class="color-green">{{ scope.row.joinNum }}</span>
              <span>/</span>
              <span class="color_b">{{ scope.row.completeNum }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('plugin.activity.status')" align="center">
            <template slot-scope="scope">{{ filersData(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('common.addTime')" min-width="130" align="center"></el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleEdit(scope.row.id,'peopleNumList')">{{ $t('common.view') }}</el-button>
              <el-button type="text" @click="handleEdit(scope.row.id,'active')">{{ $t('common.edit') }}</el-button>
              <el-button type="text" @click="deleteStore(scope.row.id)">{{ $t('common.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.size" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <active-edit-add ref="active" v-if="activeShow" @callback="callback"></active-edit-add>
    <active-people-num-list ref="peopleNumList" v-if="peopleNumList" @callback="callback"></active-people-num-list>
  </div>
</template>
<script>
import { getActiveList, removeActive } from '@/api/plugins.js';
import activeEditAdd from './components/active-edit-add.vue';
import ActivePeopleNumList from './components/active-peopleNum-list.vue';
export default {
  components: { activeEditAdd, ActivePeopleNumList },
  data() {
    return {
      peopleNumList: false,
      activeShow: false,
      formInline: { page: 1, name: '' },
      list: [],
      listLoading: false,
      page: { total: 0, size: 10, currentPage: 1 },
    };
  },
  created() {
    this.getActive();
  },
  methods: {
    activityTypeLabel(type) {
      const labels = [
        this.$t('plugin.activity.firstOrderReward'),
        this.$t('plugin.activity.rushReward'),
      ];
      return labels[type - 1] || '';
    },
    getActive() {
      getActiveList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          this.page.total = res.count;
        }
      });
    },
    callback() {
      this.activeShow = false;
      this.peopleNumList = false;
      this.getActive();
    },
    setSelectRows() {},
    handleEdit(id, type) {
      if (type == 'peopleNumList') this.peopleNumList = true;
      else if (type == 'active') this.activeShow = true;
      this.$nextTick(() => {
        this.$refs[type].init(id);
      });
    },
    deleteStore(id) {
      this.$baseConfirm(this.$t('confirm.deleteItem'), null, () => {
        removeActive({ id }).then((res) => {
          if (res.code == 1) {
            this.$baseMessage(res.msg, 'success');
            this.getActive();
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getActive();
    },
    filersData(row) {
      const start = row.activityStartAt * 1000;
      const end = row.activityEndAt * 1000;
      const now = Date.now();
      if (now < start) return this.$t('plugin.activity.notStarted');
      if (now <= end) return this.$t('plugin.activity.inProgress');
      return this.$t('plugin.activity.ended');
    },
  },
};
</script>
